import logo from "../Images/BetMakersLogo.webp";

export const Footer = () => {
  return (
    <>
    <footer className="mt-auto w-100">
      <div className='text-center p-3 align-bottom' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        <span className="p-1">Powered by:   </span>
        <a href='https://betmakers.com/'>
            <img src={logo} alt="BetMakers" width="200px" className='img-fluid' />
        </a>
      </div>
    </footer>
    </>
  );
};